module.exports = __webpack_public_path__ + "static/bootstrap-button-active-8a22b172123538a8c467f378023db9a3.png";